import clsx from "clsx";
import React from "react";
import { Icon } from "./icon";
import { IDetour, IPOI } from "./map";
import { defaultMakersConfig } from "./markers";

export default function Status({
  item,
  ...props
}: {
  item: IDetour | IPOI;
} & React.HTMLAttributes<HTMLOrSVGElement>) {
  const getStatusStyles = (status: string) => {
    switch (status) {
      case "Afgerond":
        return {
          bgColor: "bg-succes",
          iconClass: "ri-badge-check-line",
          label: status,
        };
      case "Op de planning":
        return {
          bgColor: "bg-amsterdam-yellow",
          iconClass: "ri-calendar-schedule-fill",
          label: status,
        };
      case "Verwachte werkzaamheden":
        return {
          bgColor: "bg-amsterdam-blue",
          iconClass: "ri-signpost-fill",
          label: "Verwacht",
        };
      default:
        return {
          bgColor: "bg-amsterdam-orange",
          iconClass: "ri-barricade-line",
          label: status,
        };
    }
  };
  if ("detourType" in item) {
    const { bgColor, iconClass, label } = getStatusStyles(item.status);

    return (
      <div {...props} className={clsx("detour-status absolute bottom-6 left-6", bgColor)}>
        <i className={clsx(iconClass, "text-xl")} />
        {label}
      </div>
    );
  } else {
    return (
      <div
        {...props}
        className="detour-status absolute bottom-6 left-6"
        style={{
          backgroundColor: item.type.styling.backgroundColor ?? defaultMakersConfig.backgroundColor,
        }}
      >
        {/* POI's use LucidIcons */}
        <Icon
          icon={item.type.styling?.icon}
          className="p-1"
          style={{
            width: defaultMakersConfig.iconWidth,
            height: defaultMakersConfig.iconHeight,
          }}
          strokeWidth={2}
          absoluteStrokeWidth={true}
        />
        {item.type.name}
      </div>
    );
  }
}
